import Link from "next/link";
import type { ComponentProps } from "react";
import React from "react";
import { ChatPageContainer } from "~/components/common/chat/ChatPageContainer";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientDealLayout } from "~/components/common/layouts/deals/ClientDealLayout";
import Loader from "~/components/common/parts/loading/Loading";
import { useMessages } from "~/hooks/deals/useMessages";
import { useDeals } from "~/hooks/useDeals";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { PATH as DEALS_PATH } from "~/pages/deals";
import { PATH as DEAL_PATH } from "~/pages/deals/[id]";

export const Page: React.FC = () => {
	const id = useIdQueryHandler();
	const { data: deal, isLoading: isLoadingDeal } = useDeals().show(id);
	const {
		data: messages,
		mutate: mutateMessages,
		isLoading: isLoadingMessages
	} = useMessages().index(id);
	const handleMutate = React.useCallback(async () => {
		await mutateMessages?.();
	}, [mutateMessages]);
	if (
		isLoadingDeal ||
		isLoadingMessages ||
		deal === null ||
		messages === null
	) {
		return <Loader isLoading />;
	}
	const items = [
		{ as: Link, href: DEALS_PATH, label: "案件一覧" },
		{ as: Link, href: DEAL_PATH(deal.id), label: "案件詳細" },
		{ label: "施工会社とチャット" }
	] as const satisfies ComponentProps<typeof ClientDealLayout>["items"];
	return (
		<DefaultV2>
			<ClientDealLayout deal={deal} enableChat items={items} useSimpleSpHeader>
				<ChatPageContainer
					deal={deal}
					handleMutate={handleMutate}
					messages={messages}
				/>
			</ClientDealLayout>
		</DefaultV2>
	);
};
